import { createContext, useCallback, useMemo, useState } from 'react';
import { SearchTotalesMovimientosAgrupadosRequest } from '../models/SearchTotalesMovimientosAgrupadosRequest';
import { useSearchParams } from 'react-router-dom';
interface ITransactionSummaryContext {
  searchParams: SearchTotalesMovimientosAgrupadosRequest | null;
  searchTransactionSummary: (request: SearchTotalesMovimientosAgrupadosRequest) => void;
  reloadToken: number;
  reloadTransactionSummaryAndFilters: () => void;
}

export const TransactionSummaryContext = createContext<ITransactionSummaryContext>({
  reloadToken: null,
  reloadTransactionSummaryAndFilters: () => { },
  searchParams: null,
  searchTransactionSummary: () => { },
});

export const TransactionSummaryProvider = ({ children }) => {
  const [searchParamsUrl, setSearchParamsUrl] = useSearchParams();
  const [reloadToken, setReloadToken] = useState(0);

  const searchParams: SearchTotalesMovimientosAgrupadosRequest = useMemo(() => {
    const mes = searchParamsUrl.get('mes');
    const anio = searchParamsUrl.get('anio');
    const centroCostoPadreId = searchParamsUrl.get('centroCostoPadreId');
    const numeroCuenta = searchParamsUrl.get('numeroCuenta');
    const idTarjeta = searchParamsUrl.get('idTarjeta');
    return {
      mes: mes ? Number(mes) : null,
      anio: anio ? Number(anio) : null,
      agruparPor: searchParamsUrl.get('agruparPor') || ('CUENTA' as any),
      numeroCuenta: numeroCuenta ? Number(numeroCuenta) : null,
      centroCostoPadreId: centroCostoPadreId ? Number(centroCostoPadreId) : null,
      idTarjeta: idTarjeta ? Number(idTarjeta) : null,
    };
  }, [searchParamsUrl]);

  const searchTransactionSummary = useCallback(
    (request: SearchTotalesMovimientosAgrupadosRequest) => {
      const rawData = {
        mes: request.mes,
        anio: request.anio,
        agruparPor: request.agruparPor,
        numeroCuenta: request.numeroCuenta,
        centroCostoPadreId: request.centroCostoPadreId,
        idTarjeta: request.idTarjeta,
      };

      // Filtramos valores nulos
      const cleanEntries = Object.entries(rawData)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => [key, String(value)]);
      setSearchParamsUrl(new URLSearchParams(cleanEntries));
      setReloadToken((v) => v + 1);
    },
    [setSearchParamsUrl],
  );

  const reloadTransactionSummaryAndFilters = useCallback(() => {
    setReloadToken((v) => v + 1);
  }, []);

  return (
    <TransactionSummaryContext.Provider
      value={{
        reloadToken,
        reloadTransactionSummaryAndFilters,
        searchParams,
        searchTransactionSummary,
      }}
    >
      {children}
    </TransactionSummaryContext.Provider>
  );
};
